var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFileStructureAlt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.8736 0.525879H30.8736V6.52588H8.8736V0.525879Z",
    fill: "#cccccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.20499 12H29.6336V18H8.20499V12Z",
    fill: "#cccccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.20499 24H31.7765V30H8.20499V24Z",
    fill: "#cccccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.204983 0.525879H6.20498V6.52588H0.204983V0.525879Z",
    fill: "#cccccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.204983 12H6.20497V18H0.204983V12Z",
    fill: "#cccccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.204983 24H6.20499V30H0.204983V24Z",
    fill: "#cccccc"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(0.125)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileStructureAlt);
export default __webpack_public_path__ + "static/media/file-structure-alt.e5e21c9448e334bb473d7bec59c67b72.svg";
export { ForwardRef as ReactComponent };